import React, {Component} from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import ListButton from '../buttons/ListButton';
import TransferListTable from '../components/TransferListTable';
import TransfersByMemoSearchFilter from '../components/TransfersByMemoSearchFilter';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {Card, CardActions, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Icon from 'material-ui/svg-icons/action/assignment-turned-in';

export class TransfersByMemoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            listComplete: false,
            loading: false,
            memo: '',
            startDate: null,
            startDateStr: ''
        };
    }

    handleFilterSelect = (value) => {
        let currentMemo = this.state.memo;
        if (currentMemo !== value) {
            this.setState({
                memo: value
            });
        }
    };

    handleFilterSubmit = (obj) => {
        const date = (obj && obj.date) ? obj.date : null;
        const memo = (obj && obj.memo) ? obj.memo : '';
        if (date && memo) {
            const searchDate = new Date(date);
            const str = searchDate.getUTCMonth() + 1 + '/' + searchDate.getUTCDate() + '/' + searchDate.getUTCFullYear();
            this.setState({
                listComplete: false,
                loading: true,
                memo: memo,
                startDate: date,
                startDateStr: str
            });
        }
    };

    /**
     * Handle event props for Detailed Sales Summary table completion
     *
     * @param isComplete
     */
    handleListComplete = (isComplete) => {
        this.setState({
            listComplete: isComplete,
            loading: false
        });
    };

    render() {
        const {
            listComplete,
            loading,
            memo,
            startDate,
            startDateStr
        } = this.state;

        const ListTitle = <span className="list-title">
            <Avatar icon={<Icon/>} className="avatar-title"/>Transfers by Memo</span>;

        const ListDescription = () => {
            return (
                <span>
                    <p>View transfers by Memo from and to all Locations since a specified date. These represent
                        Products due to arrive, displaying Locations and States they are transferred
                        from and to, the date they were created, and a unique transfer ID.</p>
                    <p>Click a transfer's <strong>View</strong> icon to view its contents. A transfer may
                        contain Product Units, Repacks, or Retail Boxes.</p>
                </span>
            );
        };

        return (
            <div className="list-container">
                <Card>
                    <CardActions style={viewStyles.actions}>
                        <ListButton basePath="/InventoryTransfers" label="List Incoming Transfers"/>
                        <ListButton basePath="/ReceivedInventoryTransfers" label="List Received Transfers"/>
                    </CardActions>

                    <ViewTitle title={ListTitle}/>

                    <CardText>
                        <ListDescription/>

                        <TransfersByMemoSearchFilter
                            labelDate="Select Date Since"
                            labelMemo="Enter a Memo value"
                            labelSubmit="Search Transfers"
                            loading={loading}
                            onSubmitFilter={this.handleFilterSubmit}
                        />

                        {startDate && memo &&
                            <div>
                                <h3>
                                    Transfers since {startDateStr}
                                </h3>

                                {!listComplete &&
                                    <div className="loader-container">
                                        <h4>Retrieving Transfers...</h4>
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            className="loader"
                                        />
                                    </div>
                                }

                                {/* Transfer Table */}
                                <TransferListTable
                                    basePath="InventoryTransfers"
                                    transferType="memo"
                                    memo={memo}
                                    startDate={startDate}
                                    listComplete={listComplete}
                                    onDataComplete={this.handleListComplete}
                                />
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/TransfersByMemoList.js